<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager']"> <i class="fa fa-building-o"></i> Lager </a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager', 'uebersicht']"> Übersicht </a>
      </li>
      @for (item of breadCrumb; track $index) {
        <li>
          @if (item.path) {
            <a [routerLink]="item.path">
              <span>{{ item.title }}</span>
            </a>
          } @else {
            <span>{{ item.title }}</span>
          }
        </li>
      }
    </ul>
  </div>

  <a href="/a/artikel/neu" target="_blank" class="bm-btn bm-btn-ghost"> Artikel hinzufügen </a>
  <input class="bm-input" type="text" (input)="quicksearchChanged($event)" placeholder="Schnellfilter" />
</div>

<div class="page-content px-4 pb-2 flex flex-col gap-2">
  @if (filterTemplate) {
    <div role="status" class="bm-alert bm-alert-info bm-alert-soft py-2 shrink-0" data-testid="template-filter-hint">
      <i class="fa fa-filter"></i>
      <span>{{ filterHint }}</span>
      <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost" (click)="removeTemplateFilter()">Filter entfernen</button>
    </div>
  } @else if (filterTemplateId !== null && articleTemplatesLoadFailed) {
    <div role="alert" class="bm-alert bm-alert-error bm-alert-soft py-2 shrink-0" data-testid="template-filter-load-failed">
      <i class="fa fa-exclamation-triangle"></i>
      <span>Bestand konnte nicht geladen werden.</span>
      <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost" (click)="removeTemplateFilter()">Filter entfernen</button>
    </div>
  } @else if (filterTemplateMissing) {
    <div role="status" class="bm-alert bm-alert-warning bm-alert-soft py-2 shrink-0" data-testid="template-filter-missing">
      <i class="fa fa-info-circle"></i>
      <span>Diese Artikelvorlage hat in diesem Lager keinen Bestand.</span>
      <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost" (click)="removeTemplateFilter()">Filter entfernen</button>
    </div>
  }
  <!-- Bei fehlender Vorlage nur ausblenden statt entfernen, damit gridApi gültig bleibt.
       Inline-Style statt Tailwind-„hidden“: der display-Wert des Grid-Hosts überstimmt die Klasse -->
  <ag-grid-angular
    class="ag-theme-quartz w-full flex-1 min-h-0"
    [style.display]="filterTemplateMissing ? 'none' : null"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="colDefs"
    [rowClassRules]="rowClassRules"
    [rowSelection]="rowSelection"
    [detailRowAutoHeight]="true"
    [alwaysShowVerticalScroll]="true"
    [localeText]="locale"
    [masterDetail]="true"
    [detailCellRendererParams]="detailCellRendererParams"
    [isExternalFilterPresent]="isExternalFilterPresent"
    [doesExternalFilterPass]="doesExternalFilterPass"
    (firstDataRendered)="onFirstDataRendered($event)"
    [pagination]="true"
    [rowData]="articleTemplates"
    [paginationPageSize]="paginationPageSize"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    (gridReady)="onGridReady($event)"
  >
  </ag-grid-angular>
</div>
